import { RootState } from 'types'
import { Action } from 'redux/actions'
import { setLocalStorage } from 'utils/localStorage'
import { OPEN_FOLDERS_STORAGE_KEY } from 'redux/constants'
import { uniq } from 'lodash'

const storeOpenFoldersInState = (state: RootState['openFolderIds']) => {
  setLocalStorage(OPEN_FOLDERS_STORAGE_KEY, state, true)
  return state
}

export default function reduce(state: RootState['openFolderIds'] = [], action: Action): RootState['openFolderIds'] {
  switch (action.type) {
    case 'OPEN_FOLDER_IDS_SET': {
      const { key, ids } = action.payload
      const newState = { ...state, [key]: uniq(ids) }
      return storeOpenFoldersInState(newState)
    }

    default:
      return state
  }
}
